<template>
	<component :is="layout" :data-theme="theme"/>
</template>

<script>
	import { mapGetters } from 'vuex'

	import ScissorsLayout from '@/layouts/scissors/scissors.vue'

	export default {
		components: {
			appScissorsLayout: ScissorsLayout
		},
		computed: {
			...mapGetters('tours', ['getLayoutName', 'getThemeName']),
			layout () {
				return this.getLayoutName
					? `app-${this.getLayoutName}-layout`
					: 'app-scissors-layout'
			},
			theme () {
				return this.getThemeName
			}
		}
	}
</script>
